<script lang="ts">
	import { findPropsByApiKey } from '@app/utils/kyc';
	import InputCity from './InputCity.svelte';

	export let props;

	$: cityProps = findPropsByApiKey(props.questions, 'lieuNaissance');
	$: countyProps = findPropsByApiKey(props.questions, 'departementNaissance');
	$: countryCodeProps = findPropsByApiKey(props.questions, 'paysNaissance');
	$: postalCodeProps = findPropsByApiKey(props.questions, 'codePostalNaissance');
</script>

<InputCity
	classNames="text-start"
	bind:cityProps
	bind:countryCodeProps
	bind:postalCodeProps
	bind:countyProps
/>
